import { DRAFT_TO_DOC_TYPE_WITH_LISTS } from "./../ricos-types";
const getFontSizeNumber = (fontSize) => {
  const pxRegex = new RegExp("[0-9]+[px]");
  return pxRegex.exec(fontSize) ? fontSize.split("p")[0] : "";
};
const hasStyleChanges = (currentHeading, inlineStyles, documentStyle) => {
  const key = DRAFT_TO_DOC_TYPE_WITH_LISTS[currentHeading];
  const headerStyle = documentStyle?.[key] || {};
  return Object.entries(inlineStyles).some(
    ([key2, value]) => headerStyle[key2] !== value
  );
};
const findOsName = () => {
  if (navigator.userAgent.indexOf("Win") !== -1) return "Windows";
  if (navigator.userAgent.indexOf("Mac") !== -1) return "MacOS";
  return null;
};
export {
  findOsName,
  getFontSizeNumber,
  hasStyleChanges
};
//# sourceMappingURL=utils.js.map
